<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="IssIssueDetailViewInfo"
                :filter_language="['order_status_name','negative_flag_name','verify_type_name']"
                :filter_thousandth="['unit_qty','multiple','issue_qty','issue_assist_qty']"
                :filter_date="['audit_time']"
                :header="tableHeader"
                :option="tableOption"
                ref="singleTable"
                :checkflg="false"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[463]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[2239]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="po_code" :label="$t('getapi[3757]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="ipo_line_no" :label="$t('getapi[3600]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1287]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[2181]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4637]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="order_status_name" :label="$t('getapi[1861]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[1419]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[1420]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4473]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="finance_status_name" :label="$t('getapi[1862]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="negative_flag_name" :label="$t('getapi[2096]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="verify_type_name" :label="$t('getapi[6774]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[2252]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[2326]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="inv_unit" :label="$t('getapi[3100]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="unit_qty" :label="$t('getapi[4287]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="multiple" :label="$t('getapi[1562]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="issue_qty" :label="$t('getapi[6785]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="issue_assist_qty" :label="$t('getapi[6786]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip fixed="right" :label="$t('getapi[6048]')" width="100">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="getISS(scope.row)" type="text" size="mini">{{$t('getapi[6761]')}}</el-button>
                </template>
            </el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="IssIssueDetailViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[1045]')" queryData="IssIssueDetailViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'issueoutdetail',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('issueoutdetail'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('IssIssueDetailViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1045]"),this.$t("getapi[13]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                //只读权
                if (that.total > 0) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('issueoutdetail',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'IssIssueDetailViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/ISS/Out/IssOutOverViewList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
               /* let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/ISS/Out/IssOutOverViewExportToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "IssIssueDetailViewInfo",
                    fromname: that.$t('getapi[1045]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 外协业务图
            getISS(data){
                let that = this
                that.$store.commit('setSharedParams', data);
                let item = {
                    label: '外协关系图',
                    name: 'issrelation',
                    path: '/issrelation/issue',
                    url: '/issrelation/issue',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/issrelation/issue'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
